<style>
@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Accounts" title="User Credit Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row mb-3">
								<div class="col-12">
									<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
										<i class="bx bx-chevrons-left"></i> Back
									</a>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-end">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1 align-items-center">
											<span>Show</span>
											<select class="form-select mx-2" style="width: auto" v-model="listing_length" @change="fetchCreditLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<!-- <div class="col-md-6 mt-2">
										<input
											type="text"
											class="form-control"
											placeholder="Search by added by / amount…"
											v-model="keyword"
											@keyup="fetchCreditLogs()"
										/>
									</div> -->
								</div>
							</div>

							<!-- Summary -->
							<div v-if="userCredit" class="row mt-3">
								<div class="col-md-12">
									<div class="alert alert-light border d-flex flex-wrap gap-4 mb-2">
                                        <div><strong>User Type:</strong> <span class="badge rounded-pill bg-info text-dark">
                                            {{ userCredit.user_type == 1 ? "Dealer" : userCredit.user_type == 2 ? "Customer" : "—" }}
                                            </span>
                                        </div>
                                        <div><strong>User Name:</strong> {{ userCredit.user_name }}</div>
										<div><strong>Credit Due:</strong><span class="text-danger fw-bold"> ₹{{ formatMoney(userCredit.credit_due_amount) }}</span></div>
										<div><strong>Credit Available:</strong> <span class="text-success fw-bold">₹{{ formatMoney(userCredit.credit_available_amount) }}</span></div>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table mt-3">
								<table class="display table">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Date</th>
											<th>Amount</th>
											<th>Credit Type</th>
											<th>Payment Type</th>
											<th>Added By</th>
										</tr>
									</thead>
									<tbody v-if="rows.length">
										<tr align="center" v-for="(log, index) in rows" :key="log.id">
											<td>{{ from != null ? from + index : index + 1 }}</td>
											<td>{{ log.converted_created_at || (log.created_at ? $filters.formatDateTime(log.created_at) : "—") }}</td>
											<td class="fw-bold">₹{{ formatMoney(log.amount) }}</td>
											<td>
                                                <span class="badge rounded-pill bg-success" v-if="log.user_credit_type == 2">Due Amount</span>
												<span class="badge rounded-pill bg-danger" v-else-if="log.user_credit_type == 1">Deposit</span>
												<span class="badge rounded-pill bg-light text-dark" v-else>—</span>
											</td>
											<td>
                                                <span class="badge rounded-pill bg-info text-dark" v-if="log.payment_type == 1">Incoming</span>
												<span class="badge rounded-pill bg-secondary" v-else-if="log.payment_type == 2">Outgoing</span>
												<span class="badge rounded-pill bg-light text-dark" v-else>—</span>
											</td>
											<td>{{ log.added_by_user_name || log.added_by || "—" }}</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" align="center">No credit logs found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="rows.length" class="float-start mt-2 d-block">
								Showing {{ from }} to {{ to }} of {{ total }} entries
							</caption>
							<nav v-if="rows.length && pagination.length" aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination mb-0">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="'p-' + index + '-' + page.label"
									>
										<a class="page-link" href="#" @click.prevent="onPageClick(page)" tabindex="-1">
											<span v-if="index === 0">Prev</span>
											<span v-else-if="index === pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserCreditLogs",
	data() {
		return {
			token: "",
			user_id: "",
			keyword: "",
			listing_length: 10,
			userCredit: null,
			rows: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: "",
		};
	},
	created() {
		this.user_id = this.$route?.params?.id || this.$route?.query?.user_id || "";
		this.fetchCreditLogs();
	},
	watch: {
		"$route.params.id"(val) {
			this.user_id = val || "";
			this.fetchCreditLogs();
		},
	},
	computed: {
		// no computed needed; API now returns flat logs + separate userCredit
	},
	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		listUrl() {
			return `/staffs/userCreditLogs?limit=${this.listing_length}&user_id=${encodeURIComponent(this.user_id || "")}&keyword=${encodeURIComponent(this.keyword || "")}`;
		},

		fetchCreditLogs(pageUrl) {
			if (!this.user_id) {
				this.rows = [];
				this.pagination = [];
				return;
			}

			this.getToken();
			const url = pageUrl || this.listUrl();
			this.active_page_url = url;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const ok = res.data.status === "true" || res.data.status === true;
					if (!ok) {
						this.userCredit = null;
						this.rows = [];
						this.pagination = [];
						return;
					}
					this.userCredit = res.data.data?.userCredit || null;
					const paginator = res.data.data?.userCreditLogs;
					this.rows = paginator?.data || [];
					this.pagination = paginator?.links || [];
					this.from = paginator?.from ?? 0;
					this.to = paginator?.to ?? 0;
					this.total = paginator?.total ?? 0;
				})
				.catch((err) => {
					console.error(err);
					this.$swal("Error", err.response?.data?.message || "Failed to load credit logs", "error");
					this.rows = [];
					this.pagination = [];
				});
		},

		onPageClick(page) {
			if (!page.url) return;
			const base = page.url;
			const sep = base.includes("?") ? "&" : "?";
			this.fetchCreditLogs(
				`${base}${sep}limit=${this.listing_length}&user_id=${encodeURIComponent(this.user_id || "")}&keyword=${encodeURIComponent(this.keyword || "")}`
			);
		},

		formatMoney(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "0.00";
			return n.toFixed(2);
		},

		creditTypeLabel(v) {
			// user_credit_type mapping not provided; keep generic labels for now.
			// Common pattern: 1 Credit Added, 2 Credit Deducted (adjust later if needed).
			const map = { 1: "Deposit", 2: "Due Amount" };
			return map[Number(v)] || `Type ${v}`;
		},
		creditPaymentTypeLabel(v) {
			// payment_type mapping for credit logs not provided; using generic mapping (1 Incoming, 2 Outgoing).
			const map = { 1: "Incoming", 2: "Outgoing" };
			return map[Number(v)] || `Type ${v}`;
		},
	},
};
</script>

